const {h, render, Component} = require('preact');
const {route} = require('preact-router');
const queryString = require('qs')

const NavItem      = require('./nav_item')
const ArticleContent = require('./article_content')
const HiddenArticle = require('./hidden_article')
const FAQSearchContainer = require('../search/faq_search')
const SupportAPIHelper = require('../../../../../support/frontend/helpers/API')
const WidgetsContainer = require('../main/widgets')
const Web2018Helper = require('../../../helper')
const SpinnerView = require('../../views/common/spinner')
const SingleActionSSA = require('../../views/self_service_actions/single_action_ssa')
const ErrorView = require('../main/error')
const InvalidFAQErrorView = require('../main/invalid_faq_error')
const Helper = require('../../../helper')

class AllArticles extends Component {
  constructor(props) {
    super(props);
    this.page = 0 ;
    this.handleSelectedArticle = this.handleSelectedArticle.bind(this);
    this.handleNeedHelpFromSearchResults = this.handleNeedHelpFromSearchResults.bind(this)
    this.getSSAConfig = this.getSSAConfig.bind(this);
    this.getSelectedArticle = this.getSelectedArticle.bind(this);
    this.hashHandler = this.hashHandler.bind(this);
    this.handleShowMore = this.handleShowMore.bind(this);
    this.makeArticlesCallAndSetResponse = this.makeArticlesCallAndSetResponse.bind(this);
    this.handleSideNavAllFAQClick = this.handleSideNavAllFAQClick.bind(this);
    this.fetchArticles = this.fetchArticles.bind(this);
    this.findArticle = this.findArticle.bind(this);
    window.addEventListener("hashchange", this.hashHandler, false);
  }

  hashHandler(){
    if(this.props.crumbs && this.props.crumbs.length>1 && window.location.hash!= "")
      route(`/faq${window.location.hash}?crumbs=${btoa(JSON.stringify(this.props.crumbs))}`)
    else
      route(`/faq${window.location.hash}`)
    window.location.reload()
  }

  componentDidMount()
  {
    this.fetchArticles(this.props.pageParams);
  }

  makeArticlesCallAndSetResponse(articlesUrl, showLoading) {
    this.setState({ 'isFailure': false, 'invalidFAQ': false });
    let errorCb = (response) => {
      this.setState({'articles': null, 'isLoading': false, 'isFailure': true})
    }
    let successCb = (response) => {
      if (Object.keys(response).length === 0) {
        this.setState({'articles': null, 'isLoading': false, 'invalidFAQ': true});
        return;
      }
      if(response)
      {
        if(response.isHidden) {
          this.setState({'article': response.article.content, 'isHidden': true})
          this.setState({'categories': response.categories.categories, 'isLoading': false})

        }
        else {
          this.setState({'articles': response, 'isLoading': false, 'hasMore': response.hasMore, 'isHidden': false})
          if(!response.isArticleInTop15 && response.article)
            this.setState({'selectedArticle': response.article.content, 'isArticleInTop15': response.isArticleInTop15})
          else
            this.setState({'selectedArticle': this.getSelectedArticle( response )})
          this.getSSAConfig( response )
        }
      }
    }
    if(showLoading)
      this.setState({'isLoading': showLoading})
    SupportAPIHelper.get(articlesUrl , null, successCb, errorCb, false);
  }

  fetchArticles(params) {
    let qs = queryString.stringify(params)
    let articlesUrl  = `${Groupon.Utils.getConfigFromDom().FAQBASEURL}/articles`;
    articlesUrl  = articlesUrl  + "?" + qs
    this.makeArticlesCallAndSetResponse(articlesUrl, true)
  }

  componentWillReceiveProps(props) {
    if(props.pageParams.categoryId && this.props.pageParams.categoryId !== props.pageParams.categoryId) {
      // if there is a change in categoryId, fetch from remote.
      this.fetchArticles(props.pageParams);
    } else if(props.pageParams.contentId && this.props.pageParams.contentId !== props.pageParams.contentId) {
      // if there's a change in contentId, first see if data is available from previous fetch, 
      // if not get it from remote.
      this.setState(state => {
        const selectedArticle = this.findArticle(state.articles, props.pageParams.contentId);
        if (selectedArticle) {
          return { selectedArticle };
        }
        this.fetchArticles(props.pageParams);
      });
    }
  }

  handleShowMore() {
    this.page = this.page + 1
    this.props.pageParams.page = this.page
    let qs = queryString.stringify(this.props.pageParams)
    let articlesUrl  = `${Groupon.Utils.getConfigFromDom().FAQBASEURL}/articles`;
    articlesUrl  = articlesUrl  + "?" + qs
    this.makeArticlesCallAndSetResponse(articlesUrl, false)
  }

  handleSelectedArticle(article){
    this.setState({'selectedArticle': article})
    if (article) {
      Helper.createClickEventInbenta(article.clickCode)
    }
  }

  getSelectedArticle(response){
    let selectedArticle = response.articles.contents.filter(article => article.contentId == this.props.pageParams.contentId);
    if (selectedArticle[0]) {
      Helper.createClickEventInbenta(selectedArticle[0].clickCode)
    }
    return selectedArticle.length>0?selectedArticle[0]:response.articles.contents[0]

  }

  findArticle(response, contentId){
    if(!response || !response.articles || !Array.isArray(response.articles.contents)) {
      return null;
    }
    // prsinha: not sure what is the use case to use filter instead of find. can there be
    // more than one article with a given contentId?
    let selectedArticle = response.articles.contents.filter(article => article.contentId == contentId);
    if (selectedArticle.length > 0) {
      Helper.createClickEventInbenta(selectedArticle[0].clickCode)
      return selectedArticle[0]
    }
    return null;
  }

  getArticleSideNav(){
    if(this.state.articles){
      let navItems = []
      let articles = this.state.articles.articles
      for(var articleIdx in articles.contents)
      {
        let article = articles.contents[articleIdx]
        navItems.push(<NavItem article={article} selectedIndex={this.state.selectedArticle.contentId} handleSelectedArticle={this.handleSelectedArticle} crumbs={this.props.crumbs}/>)
      }
      return navItems
    }
    return null
  }

  handleNeedHelpFromSearchResults(selectedInbentaResult){
    selectedInbentaResult = _.omit(selectedInbentaResult, 'answer', 'bloodhoundTracking')
    let configFromDom = Groupon.Utils.getConfigFromDom()
    let qs = Web2018Helper.getQueryStringForFAQToContactChannels(selectedInbentaResult)
    if (configFromDom && configFromDom.user){
        route(`/customer_support/web/contact_channels?${ qs }`);
    }
    else{
      if(Web2018Helper.canSkipLogIn(configFromDom, selectedInbentaResult)){
        route(`/customer_support/web/contact_channels?${ qs }`);
      } 
      else if(configFromDom.guestCheckoutEnabledInWeb && this.props.guestOrder) { // guest checkout help
        route(`/customer_support/web/contact_channels?${ qs }`);
      }
      else
      {
        let queryString = Web2018Helper.getQueryStringForFAQToContactChannels(selectedInbentaResult, { encode: false })
        let referenceUrl = `${configFromDom.SUPPORTBASEURL}?${ queryString }`
        window.location.href = `/login?return_to=${ encodeURIComponent(referenceUrl) }`
      }
    }
  }

  getSSAConfig( response  ){
    let landingPageFAQs = Groupon.Utils.getConfigFromDom().landingPageFAQs
    let ssa = undefined
    for(let faqIndex in landingPageFAQs){
      if(landingPageFAQs[faqIndex].categoryId == response.category.categoryId){
        ssa = landingPageFAQs[faqIndex]
        break
      }
    }
    this.setState({'ssaConfig': ssa})
  }

  getSSActionUrl(url){
    return url.replace(/:user_id/i, JSON.parse(Groupon.Utils.getConfigFromDom().user).id)
  }

  handleSideNavAllFAQClick(e) {
    e.preventDefault();
    route(Groupon.Utils.getConfigFromDom().FAQBASEURL); 
  }

  render() {
    if(this.state.isLoading)
      return <SpinnerView/>
    if (this.state.isFailure)
      return (<ErrorView/>)
    if (this.state.invalidFAQ)
      return (<InvalidFAQErrorView/>)
    if(this.state.articles || (this.state.isHidden && this.state.article))
    {
    return (
      <div>
        <div style="margin-left: 28px">
          <FAQSearchContainer/>
        </div>
        {this.state.isHidden && 
          <HiddenArticle onGuestHelp={this.props.onGuestHelp} showGuestHelp={this.props.showGuestHelp}  article={this.state.article} handleNeedHelpFromSearchResults={this.handleNeedHelpFromSearchResults} categories={this.state.categories}/>
        }
        { !this.state.isHidden && 
        <article id="articles-content" class="tab-contents">
          <section id="topics-content" class="tab-content active">
            <aside class="topics-side-nav">
              {Groupon.Utils.getConfigFromDom().user && this.state.ssaConfig && this.state.ssaConfig.selfServiceActions && (
              <div>
                <div class='ssa faq-ssas' data-bhw={"web2018_faq_self_service_actions"}>
                {this.state.ssaConfig.selfServiceActions.map((action,i) =>
                  <SingleActionSSA SSADetails={{'SSAText':action.title,'UrlForSSA':this.getSSActionUrl(action.url)}} />
                )}
                </div>
                <div class='divider'></div>
              </div>
              )
              }
              <ul id="articles-secondary-nav" class="unstyled">
                {
                 this.props.fromFaq && (<li class="view_all_faqs">
                    <span class='back-all-faqs'></span>
                    <a href="" onClick={this.handleSideNavAllFAQClick} data-bhw="web2018_back_all_faqs">{I18n.translate("js.modules.web_2018.all_faqs_back_link")}</a>
                  </li>)
                }
                  <li class="selected_topic">
                    <a>{this.state.articles.category.title}</a>
                  </li>
                  {this.getArticleSideNav()}
              </ul>
            { this.state.hasMore &&
              <span class="show-more" onClick={this.handleShowMore}>{I18n.translate("js.modules.web_2018.show_more")}</span>
            }
            </aside>
            <ArticleContent onGuestHelp={this.props.onGuestHelp} showGuestHelp={this.props.showGuestHelp} article={this.state.selectedArticle} handleNeedHelpFromSearchResults={this.handleNeedHelpFromSearchResults}/>
          </section>
        </article>
      }
      <WidgetsContainer isFaq="true"/>
      </div>
    )
  }
  }
}

module.exports = AllArticles
